/**
 * Electron desktop print routing (web/Android never load this path).
 * ESC/POS raw print is only for thermal roll formats (2"/3"). Sheet sizes (A4, A5, A6) use PDF.
 */

function deriveBaseFromCustomKey(printFormat) {
  const u = String(printFormat).toUpperCase();
  if (u.includes('3INCHSIMPLE') || u.includes('3_INCH_SIMPLE')) {
    return '3_INCH_SIMPLE';
  }
  if (u.includes('3INCHGST') || u.includes('3_INCH_GST')) {
    return '3_INCH_GST_DETAILS';
  }
  if (u.includes('2INCH') || u.includes('2_INCH')) {
    return '2_INCH_SIMPLE';
  }
  if (u.includes('A6')) {
    return 'A6_FORMAT_1';
  }
  if (u.includes('A5')) {
    return 'A5_FORMAT_1';
  }
  if (u.includes('A4')) {
    return 'A4';
  }
  return 'A4';
}

/** Saved Print Format Customizer layouts use CUSTOM_* keys with template_config on the server. */
export function isCustomPrintFormat(printFormat) {
  return Boolean(printFormat && String(printFormat).trim().toUpperCase().startsWith('CUSTOM_'));
}

export function normalizePrintFormat(printFormat) {
  if (!printFormat) {
    return null;
  }
  let u = String(printFormat).trim().toUpperCase();
  if (u.startsWith('CUSTOM_')) {
    u = deriveBaseFromCustomKey(u);
  }
  if (u === '3_INCH') {
    return '3_INCH_SIMPLE';
  }
  return u;
}

/** True when Electron should send ESC/POS bytes to the thermal printer. */
export function isEscPosPrintFormat(printFormat) {
  const base = normalizePrintFormat(printFormat);
  if (!base) {
    return false;
  }
  return base.startsWith('2_INCH') || base.startsWith('3_INCH');
}

export function shouldElectronUseEscPos(printFormat) {
  return Boolean(
    typeof window !== 'undefined'
    && window.electronAPI?.printEscPos
    && isEscPosPrintFormat(printFormat)
  );
}

/**
 * SumatraPDF / pdf-to-printer options for sheet receipts (desktop only).
 * A6/A5/A4 PDFs must use noscale + matching paperSize — shrink + wrong paper
 * often prints blank or off-area on pre-printed stationery.
 */
export function getElectronPdfPrintOptions(printFormat) {
  const base = normalizePrintFormat(printFormat);
  const opts = { scale: 'noscale', silent: true };

  if (!base) {
    return { scale: 'shrink', silent: true };
  }

  if (base === 'A6_FORMAT_1' || base.includes('A6')) {
    return { ...opts, paperSize: 'A6' };
  }

  if (
    base === 'A5_FORMAT_1'
    || base === 'A5_FORMAT_2_DOUBLE'
    || base === 'A5_FORMAT_2_DOUBLE_GST'
    || base.startsWith('A5')
  ) {
    return { ...opts, paperSize: 'A5', orientation: 'landscape' };
  }

  if (base.startsWith('A4')) {
    return { ...opts, paperSize: 'A4' };
  }

  return { scale: 'shrink', silent: true };
}
